import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

export function stockItemEditPath({ productId, supplyId, itemKind } = {}) {
    if (itemKind === 'supply' || (supplyId != null && productId == null)) {
        if (supplyId != null) {
            return `/production/supplies/${supplyId}/edit`;
        }
    }
    if (productId != null) {
        return `/production/products/${productId}/edit`;
    }
    return null;
}

/**
 * Link para edição de produto ou insumo em relatórios.
 */
export default function ReportStockItemLink({
    productId,
    supplyId,
    itemKind,
    children,
    className,
}) {
    const path = stockItemEditPath({ productId, supplyId, itemKind });
    const label = children ?? '-';

    if (!path) {
        return <span className={className}>{label}</span>;
    }

    return (
        <Link
            to={path}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
                'text-primary-600 hover:text-primary-800 hover:underline font-medium',
                className,
            )}
        >
            {label}
        </Link>
    );
}
